export const MAX_FILES = 10 as const;
export const MAX_SIZE_MB = 8;
export const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
